module.exports = __webpack_public_path__ + "img/club_bg.a096f035.png";